export default __webpack_public_path__ + "static/media/expiration-icon.0ae1017f.svg";